import React from "react";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8 text-gray-900">Privacy Policy</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-8">Last Updated: December 2025</p>
          
          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-gray-900">1. Information We Collect</h2>
              <p>
                We collect personal information that you voluntarily provide when joining our network, including your name, email address, and your selected primary area of interest (e.g., Product Design, Team Leadership).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-gray-900">2. How We Use Your Information</h2>
              <p className="mb-2">Your data is used specifically to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Organize project teams based on your indicated skills.</li>
                <li>Deliver relevant project briefs and onboarding materials.</li>
                <li>Facilitate collaboration within our student-led network.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-gray-900">3. Data Storage and Security</h2>
              <p>
                We implement industry-standard security measures to protect your data from unauthorized access. We do not sell or rent your personal information to third parties.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-gray-900">4. Your Choices</h2>
              <p>
                You may request to view, update, or delete your information at any time by contacting us through the links provided in our footer.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;

